import * as Sentry from '@sentry/react'
import { env } from '@/config/env'
import { ApiError } from '@/lib/api'

/** Sentry when `VITE_SENTRY_DSN` is set. Expected API errors (4xx the UI shows) are not reported; tokens never are. */
export function initMonitoring(): void {
  if (!env.sentryDsn) return
  Sentry.init({
    dsn: env.sentryDsn,
    release: `leazepro-webapp@${__APP_VERSION__}`,
    environment: env.appEnv,
    tracesSampleRate: env.appEnv === 'production' ? 0.1 : 0,
    beforeSend(event, hint) {
      const error = hint.originalException
      if (error instanceof ApiError && error.status < 500 && error.status !== 0) return null
      return event
    },
    beforeBreadcrumb(crumb) {
      if (crumb.category === 'fetch' || crumb.category === 'xhr') {
        if (crumb.data?.url) crumb.data.url = String(crumb.data.url).replace(/([?&](token|refreshToken|otp)=)[^&]+/g, '$1[redacted]')
      }
      return crumb
    },
  })
}

export function reportError(error: unknown, context: Record<string, unknown> = {}): void {
  if (!env.sentryDsn) {
    if (env.isDev) console.error('[monitoring]', error, context)
    return
  }
  Sentry.captureException(error, { extra: context })
}

/** Who the session belongs to — the id only, never name, mobile or email. */
export function setMonitoredUser(id: string | null): void {
  if (!env.sentryDsn) return
  Sentry.setUser(id ? { id } : null)
}
